module.exports = __webpack_public_path__ + "img/039-monaco.fe2e9f3b.svg";